import React from "react";
import { CLASSES } from "../../constants";

/**
 * File path bar component showing current file path and save button
 * @param {Object} props - Component props
 * @param {string} props.filePath - Current file path
 * @param {boolean} props.isDirty - Whether file has unsaved changes
 * @param {boolean} props.isSaving - Whether file is being saved
 * @param {Function} props.onSave - Save handler
 * @param {boolean} props.isReadOnly - Whether editor is in read-only mode
 * @returns {JSX.Element} The file path bar
 */
const FilePathBar = ({ filePath, isDirty, isSaving, onSave, isReadOnly }) => {
  return (
    <div className="bg-gray-50 dark:bg-neutral-900 px-4 py-2 text-xs text-neutral-500 dark:text-neutral-400 flex justify-between items-center border-b border-neutral-200 dark:border-neutral-700">
      <div className="flex items-center">
        <span
          className="font-medium text-xs truncate max-w-[300px]"
          title={filePath}
        >
          {filePath}
        </span>
        {isDirty && !isReadOnly && (
          <span className="ml-2 text-xs text-orange-500 dark:text-orange-400">
            ●
          </span>
        )}
        {isReadOnly && (
          <span className="ml-2 text-xs text-neutral-400 dark:text-neutral-500">
            (Read-only)
          </span>
        )}
      </div>

      <div className="flex items-center gap-2">
        {isDirty && !isReadOnly && (
          <button
            onClick={onSave}
            disabled={isSaving}
            className={CLASSES.saveButton}
            data-tour="save-file"
          >
            {isSaving ? "Saving..." : "Save"}
            <span className="text-[10px] opacity-75">(⌘S)</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default FilePathBar;
